import CircularProgress from "@material-ui/core/CircularProgress";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { trackEvent } from "../../../_utils/GoogleAnalytics";
import { buildLocaleQuery, parseLocaleQuery, resolveLocaleContext } from "../../../_utils/localeContext";
import "../../../styles/CustomButton.css";
import "../../../styles/Input.css";
import "../styles/Search.css";

class Search extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            email_error_message: ""
        };
    }

    getResolvedContext = () => {
        return resolveLocaleContext({
            search: this.props.location.search,
            store: this.props.store,
            language: this.props.language,
            country: this.props.country,
            storeList: this.props.store_list,
            countryList: this.props.country_list
        });
    };

    getViewQueryParameters() {
        const resolved = this.getResolvedContext();

        if (JSON.stringify(this.props.store) !== JSON.stringify(resolved.store)) {
            this.props.setStore(resolved.store);
        }

        if (this.props.language !== resolved.language) {
            this.props.setLanguage(resolved.language);
        }

        if (this.props.country !== resolved.country) {
            this.props.setCountry(resolved.country);
        }
    }

    componentDidMount() {
        this.props.resetLanguage();
        this.props.resetStore();
        this.props.resetCountry();

        if (this.props.language_list.length === 0) {
            this.props.getLanguages();
        }

        if (this.props.store_list.length === 0) {
            this.props.getStores();
        }

        if (this.props.country_list.length === 0) {
            this.props.getCountries();
        }

        this.getViewQueryParameters();
        this.postMessageToParentWindow();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.loading === false && prevProps.loading === true && !this.props.err) {
            const { locale } = this.getResolvedContext();
            this.props.updateSearchMessage(locale.FORGOT_ORDER_NUMBER_PAGE.EMAIL_SENT);
            this.handleBack();
        }

        if (this.props.loading === false && prevProps.loading === true && this.props.err) {
            const { locale } = this.getResolvedContext();
            this.props.updateSearchMessage(locale.FORGOT_ORDER_NUMBER_PAGE.EMAIL_NOT_FOUND);
        }

        if (
            this.props.language_list !== prevProps.language_list ||
            this.props.store_list !== prevProps.store_list ||
            this.props.country_list !== prevProps.country_list
        ) {
            this.getViewQueryParameters();
        }

        this.postMessageToParentWindow();
    }

    postMessageToParentWindow() {
        let rootElement = document.getElementById("root");
        let height = Math.max(rootElement.scrollHeight, rootElement.offsetHeight, rootElement.clientHeight);

        let data = {
            action: "SITE_UPDATED",
            height
        };
        window.parent.window.postMessage(JSON.stringify(data), "*");
    }

    getNavigationLocaleParams() {
        const localeQuery = parseLocaleQuery(this.props.location.search);
        const queryStores = Array.isArray(localeQuery.stores) ? localeQuery.stores : [];

        return {
            store: queryStores.length > 0 ? queryStores : this.props.store,
            language: localeQuery.language || this.props.language,
            country: localeQuery.country || this.props.country
        };
    }

    handleInputChange = (input_name, e) => {
        this.setState({
            [input_name]: e.target.value,
            [`${input_name}_error_message`]: ""
        });
    };

    handleBack = () => {
        trackEvent("Forgot Order", "Back to Search", "true");
        const query = buildLocaleQuery(this.getNavigationLocaleParams());
        this.props.history.push(`/embedded/search?${query}`);
    };

    handleBackButton = () => {
        this.props.resetSearchMessage();
        this.handleBack();
    };

    sendOrdersSummaryEmail = () => {
        trackEvent("Forgot Order", "Send Email", "true");
        this.props.sendOrdersSummaryEmail(this.state.email.trim(), this.props.store);
    };

    resetErrorMessages() {
        this.setState({
            email_error_message: ""
        });
    }

    handleSubmit = () => {
        this.props.resetSearchMessage();
        this.resetErrorMessages();

        const { locale } = this.getResolvedContext();
        const forgotLocale = locale.FORGOT_ORDER_NUMBER_PAGE;
        const email = this.state.email.trim();

        if (!email) {
            this.setState({
                email_error_message: forgotLocale.EMAIL_ADDRESS_INPUT.ERROR_REQUIRED
            });
            return;
        }

        const emailRegex = /.+@.+\..+/;
        if (!emailRegex.test(email)) {
            this.setState({
                email_error_message: forgotLocale.EMAIL_ADDRESS_INPUT.ERROR_INVALID
            });
            return;
        }

        this.sendOrdersSummaryEmail();
    };

    render() {
        const { locale } = this.getResolvedContext();

        return (
            <section className="flex layout horizontal center-center">
                {this.props.language_list_loading || this.props.store_list_loading || this.props.country_list_loading ? (
                    <CircularProgress className="loading-progress" size={74} color="primary" thickness={6} />
                ) : (
                    <div className="flex layout vertical forgot-order-no-main-frame">
                        <div className="box">
                            <div className="row">
                                <div className="column">
                                    <h1 className="layout vertical frame-heading center-center">{locale.FORGOT_ORDER_NUMBER_PAGE.HEADING}</h1>
                                </div>
                            </div>
                        </div>

                        <div className="box">
                            <div className="row">
                                <div className="column">
                                    <div className="sub-heading">{locale.FORGOT_ORDER_NUMBER_PAGE.SUBHEADING}</div>
                                </div>
                            </div>
                        </div>
                        {this.props.search_message && (
                            <div className="box">
                                <div className="row">
                                    <div className="column">
                                        <div className="message-box">{this.props.search_message}</div>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className="box">
                            <div className="row">
                                <div className="column">
                                    <div className="input-box">
                                        <div className="flex">
                                            <div className="input-heading">{`*${locale.FORGOT_ORDER_NUMBER_PAGE.EMAIL_ADDRESS_INPUT.HEADER}`}</div>
                                        </div>
                                        <div className="flex layout horizontal">
                                            <input onChange={e => this.handleInputChange("email", e)} className="custom-input" />
                                        </div>
                                        <div className="flex input-error-box">
                                            <div className="input-helper-text">{this.state.email_error_message}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="box">
                            <div className="row">
                                <div className="flex layout dynamic-direction-mobile-portrait buttons">
                                    <div className="column">
                                        <button className="custom-button negative" onClick={this.handleBackButton}>
                                            <div className="layout vertical inbutton-text">{locale.FORGOT_ORDER_NUMBER_PAGE.BACK_BUTTON_TEXT}</div>
                                        </button>
                                    </div>
                                    <div className="column">
                                        <button
                                            disabled={this.props.loading}
                                            className={`custom-button layout horizontal center-center ${this.props.loading ? " loading" : ""}`}
                                            onClick={this.props.loading ? null : this.handleSubmit}
                                        >
                                            <div className="layout vertical center-center inbutton-text">
                                                {this.props.loading ? (
                                                    <CircularProgress size={24} className="circular-loading" thickness={6} />
                                                ) : (
                                                    locale.FORGOT_ORDER_NUMBER_PAGE.SEND_BUTTON_TEXT
                                                )}
                                            </div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </section>
        );
    }
}

export default withRouter(Search);
